// @flow
import React from 'react';
import {Input} from 'reactstrap'
import {commons} from "./../utils";
import AbstractField from "./AbstractField";

class NumberField extends AbstractField {

    static PropTypes = {
        int: React.PropTypes.bool,
        double: React.PropTypes.bool,
    };

    static defaultProps = {
        int: false,
        double: false,
    };

    handleChange = (e) => {
        const {onChange, value, double, int} = this.props;
        const textValue = e.target.value;

        let normalizeFunc;
        if (double) {
            normalizeFunc = commons.normalizeDouble;
        } else if (int) {
            normalizeFunc = commons.normalizeInt;
        } else {
            normalizeFunc = commons.normalizeInt;
        }

        const normalizedValue = normalizeFunc(textValue);
        normalizedValue !== value && onChange(normalizedValue);
    };

    handleBlur = () => {
        const {onBlur, value} = this.props;
        if (onBlur) {
            onBlur(value);
        }
    };

    render() {
        const {addonsBefore, addonsAfter, value, double, int, onBlur, onChange, ...props} = this.props;

        let inputValue;
        if (double) {
            inputValue = commons.normalizeDoubleForUser(value);
        } else if (int) {
            inputValue = value;
        } else {
            inputValue = value;
        }

        const field = <Input
            type="text"
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={inputValue}
            {...props}
        />;

        return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
    }
}
export default NumberField;
